import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IBreadcrumb, IPortalConfig } from 'src/app/models';
import { PortalService, RoutingService } from 'src/app/services';

@Component({
  selector: 'medpt-admin-breadcrumb',
  templateUrl: './admin-breadcrumb.component.html',
  styleUrls: ['./admin-breadcrumb.component.scss'],
  standalone: false
})
export class AdminBreadcrumbComponent implements OnInit {
  @Input() Breadcrumbs: IBreadcrumb[] = [];
  routeChangeSubscription!: Subscription;
  globaPortalInfo: IPortalConfig = null!;
  portalInfo: IPortalConfig = null!;
  isClientAdmin: boolean = true;
  AdminRootText: string = "";
  AdminRootLink: string = "";
  AdminRootLinkQueryParam: object = {};

  constructor(
    private portalService: PortalService,
    private routingService: RoutingService  ) {
  
  }

  ngOnInit(): void {
    this.isClientAdmin = this.routingService.IsClientAdmin();
    this.portalInfo = this.portalService.portalConfiguation.getValue();
    this.globaPortalInfo = this.portalService.globalPortalConfiguration.getValue();

    this.AdminRootText = this.isClientAdmin ? (this.globaPortalInfo != null) ? "Program Administration" : "Portal Administration" : "MedPoint Portal Tools";
    this.AdminRootLink = `/Admin/${this.portalInfo.SponsorName}/${this.globaPortalInfo != null ? this.globaPortalInfo.PortalName : this.portalInfo.PortalName}/${this.isClientAdmin ? "ClientAdministration" : "MedPointAdministration"}`;

    this.AdminRootLinkQueryParam = {};
    if (this.globaPortalInfo != null) {
      this.AdminRootLinkQueryParam = { Portal: this.portalInfo.PortalName };
    }

    this.Breadcrumbs.forEach((item:IBreadcrumb) => {
      if (this.globaPortalInfo != null) {
        item.queryParams = { Portal: this.portalInfo.PortalName, ...(item.queryParams ?? {}) };
      }
      item.Url = this.AdminRootLink + (item.IsLink ? (item.Url ?? '') : '');
    });
  }

}
